module.exports = __webpack_public_path__ + "img/nf.f5c3f9dc.svg";